import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { Core } from "../helpers/core";
import { AppIcons } from "../constants/app-icons";
import { DOMAIN } from "./domain-constant";

export default class VendorsService extends ApiService {
  namespace = "vendor";
  template = "defaultTemplate";
  DOMAIN = DOMAIN.VENDOR;
  icon = "vendors";
  favicon = "OrangeSilhouette";
  search = true;
  action = "action";
  data = [];
  name = "Vendor";
  Width = 1200;
  singular = this.terminology.vendor.singular;
  plural = this.terminology.vendor.plural;
  vowel = this.terminology.vendor.vowel;
  gemItems = [
    {
      key: "create",
      label: this.t("addNewEntity", { entity: this.name }),
      icon: AppIcons.PLUS,
    },

    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.name }),
      icon: AppIcons.BULLETS,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.ALARM,
      field: "display_name",
    },
    {
      header: this.t("primaryPhone"),
      icon: AppIcons.MOBILE_PHONE,
      field: "primary_phone",
    },

    {
      header: this.t("since"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "account_since",
      template: (data) => {
        return Core.datePeriod(this.parseDateMoment(data["account_since"]));
      },
    },
    {
      header: this.t("number"),
      icon: AppIcons.BARCODE,
      field: "account_number",
    },
    {
      header: this.t("balance"),
      icon: AppIcons.MONEY,
      field: "balance",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),

      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];

  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: this.t("editAnEntity", { entity: this.name }),
        icon: AppIcons.EDIT,
      },
      {
        key: "announce",
        label: "announceThisEntity",
        services: DOMAIN.MESSAGES,
        icon: AppIcons.ANNOUNCEMENT,
      },
      {
        key: "email",
        label: "emailThisEntity",
        icon: AppIcons.MAIL,
        services: DOMAIN.EMAIL,
      },
      {
        key: "bookmark",
        label: "bookmarkThisEntity",
        icon: AppIcons.BOOKMARK,
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? AppIcons.DISABLE : AppIcons.ENABLED,
      },
    ];
    return listMenuItems;
  }
  filterItems = [
    { name: "Types", serviceId: "2", value: "2", realm: "2", selected: false },
    {
      name: "Categories",
      serviceId: "3",
      value: "3",
      realm: "1",
      selected: true,
    },
    {
      name: "Folders",
      serviceId: "-2",
      value: "-2",
      realm: "0",
      selected: false,
    },
  ];

  constructor() {
    super("vendors");
  }
}
